import { NgModule, Component, Injectable } from '@angular/core';

import {
    RouterModule,
    Routes,
    CanActivate,
    ActivatedRouteSnapshot
} from '@angular/router';

import { BaseComponent } from './base/base.component';
import { AllOrdersComponent } from './all-orders/all-orders.component';
import { MyOrdersComponent } from './my-orders/my-orders.component';
import { HistoryComponent } from './history/history.component';
import { ResourceOrdersComponent } from './resource-orders/resource-orders.component';

import { AllOrdersResolves } from './all-orders/all-orders.resolver';
import { MyOrdersResolver } from './my-orders/my-orders.resolver';
import { HistoryResolver } from './history/history.resolver';
import { ResourceOrdersResolver } from './resource-orders/resource-orders.resolver';

import { underShardResources } from './constants';

@Injectable()
export class CanTokenOnly implements CanActivate {
    canActivate(
        route: ActivatedRouteSnapshot
    ) {
        return route.params.resourceType === 'token';
    }
}

@Injectable()
export class ResourcesOnly implements CanActivate {
    canActivate(
        route: ActivatedRouteSnapshot
    ) {
        return underShardResources.includes(route.params.resourceType);
    }
}

const routes: Routes = [
    {
        path: 'market',
        component: BaseComponent,
        children: [
            {
                path: 'all',
                component: AllOrdersComponent,
                resolve: {
                    shard: AllOrdersResolves
                },
                children: [
                    {
                        path: ':shard/:resourceType',
                        component: ResourceOrdersComponent,
                        resolve: {
                            data: ResourceOrdersResolver
                        }
                    },
                    {
                        path: ':resourceType',
                        component: ResourceOrdersComponent,
                        resolve: {
                            data: ResourceOrdersResolver
                        },
                        canActivate: [ResourcesOnly]
                    }
                ]
            }, {
                path: 'my',
                component: MyOrdersComponent,
                resolve: {
                    item: MyOrdersResolver
                }
            }, {
                path: 'history',
                component: HistoryComponent,
                resolve: {
                    item: HistoryResolver
                }
            }, {
                path: '',
                pathMatch: 'full',
                redirectTo: 'all'
            }
        ]
    }
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [CanTokenOnly, ResourcesOnly]
})
export class MarketRouting { }
